import JFormItem from './form-item'

export default JFormItem



// WEBPACK FOOTER //
// ./src/components/form-item/index.js